import React from 'react';
import CommentsList from "../core/comments/CommentsList";
import {useParams} from "react-router-dom";
import {Container} from "@material-ui/core";

const CommunicatorViewCommentsComponents = () => {

    const {shipmentId} = useParams();

    return (
        <Container>
            <CommentsList shipmentId={shipmentId} withCommentDetails/>
        </Container>
    );
};

export default CommunicatorViewCommentsComponents;